import React from 'react';

// Style
import 'components/Carts/CartChemicalProbes/CartChemicalProbes.scss';
import 'components/Carts/CartPfizer/CartPfizerRow.scss';

// Redux
import { Link } from 'react-router-dom';

// Classname
import clsx from 'clsx';

// Components
import DropdownPrice from 'components/DropdownPrice';
import CountControll from 'components/CountControll';
import FieldCheckbox from 'components/UiKit/FieldCheckbox';

export const DataRowItem = (props: any) => {
	const {
		id,
		to,
		cas,
		name,
		isPOA,
		onStock,
		selected,
		titlePOA,
		quantity,
		numeration,
		currentPrice,
		handleClickPlus,
		handleClickMinus,
		convertedOptions,
		currentTypePrice,
		optionsTypePrices,
		handleChangePrices,
		handleChangeCheckbox,
		handleChangeTypePrice,
		classNameWrapper,
	} = props;

	const labelStoke = onStock ? 'In Stock' : 'Out of<br />Stock';
	const innerTitleClass = onStock ? 'pfizer-row__dropdown-price--in-stock' : 'pfizer-row__dropdown-price--out-of-stock';

	const cnWrapper = clsx(
		'pfizer-row flex flex-ai-center full-width',
		classNameWrapper ? classNameWrapper : '',
	);

	return <div className={cnWrapper}>
		<FieldCheckbox
			readOnly
			label={numeration}
			value={onStock && selected}
			disabled={!onStock || isPOA}
			name="checkboxItemCartPfizer"
			className="pfizer-row__checkbox"
			onChange={handleChangeCheckbox(id || '')}
		/>
		<Link to={to} className="pfizer-row__id">{id}</Link>
		<p className="pfizer-row__cas pr5">{cas}</p>
		<div className="pfizer-row__name pr5" dangerouslySetInnerHTML={{ __html: name || '' }} />

		<DropdownPrice
			titlePOA={titlePOA}
			withUrlParam={false}
			innerTitle={labelStoke}
			options={convertedOptions}
			currentPrice={currentPrice}
			typePrice={currentTypePrice}
			onChange={handleChangePrices}
			optionsRadio={optionsTypePrices}
			innerTitleClass={innerTitleClass}
			className="pfizer-row__dropdown-price"
			handlerChangeTypePrice={handleChangeTypePrice}
		/>

		<CountControll
			isCart
			isHideTitle
			innerCount={quantity}
			className="flex-jc-end"
			innderDisabled={!selected}
			handlerPlus={handleClickPlus}
			handlerMinus={handleClickMinus}
		/>
	</div>;
};

export default DataRowItem;